import { defineStore } from "pinia";
import { ref } from "vue";
export const useNotificationStore = defineStore("notifications", () => {
    const notifications = ref([]);
    let nextId = 0;
    function show(message, type = "info", timeout = 5000) {
        const id = nextId++;
        notifications.value.push({ id, message, type, timeout });
        if (timeout > 0) {
            setTimeout(() => {
                remove(id);
            }, timeout);
        }
        return id;
    }
    function success(message, timeout = 3000) {
        return show(message, "success", timeout);
    }
    function error(message, timeout = 6000) {
        return show(message, "error", timeout);
    }
    function warning(message, timeout = 5000) {
        return show(message, "warning", timeout);
    }
    function info(message, timeout = 4000) {
        return show(message, "info", timeout);
    }
    function remove(id) {
        const index = notifications.value.findIndex((n) => n.id === id);
        if (index !== -1) {
            notifications.value.splice(index, 1);
        }
    }
    function clear() {
        notifications.value = [];
    }
    return {
        notifications,
        show,
        success,
        error,
        warning,
        info,
        remove,
        clear,
    };
});
